import React from 'react';
import {Box, FormControl, TextArea as InputNative} from 'native-base';
import {message} from '../../../utils/messages';
import {defaultProps} from '../constants';

interface Props {
  value: string;
  label: string;
  icon?: any;
  width?: string;
  backgroundColor?: string;
  numberOfLines?: number;
  maxLength?: number;
}

export const ReadonlyTextArea = (props: Props) => {
  const {value, label, icon, width, backgroundColor, numberOfLines, maxLength} =
    props;
  const InternalIcon = () => <Box marginLeft={5}>{icon}</Box>;

  return (
    <Box width={width ?? '100%'} marginBottom={5}>
      <FormControl>
        <FormControl.Label>{message(label)}</FormControl.Label>
        <InputNative
          autoCompleteType={undefined}
          InputLeftElement={icon ? <InternalIcon /> : <></>}
          {...defaultProps}
          backgroundColor={'white'}
          value={value}
          isReadOnly={true}
          _input={{
            color: '#858597',
            backgroundColor,
          }}
          {...{numberOfLines}}
          maxLength={maxLength}
        />
      </FormControl>
    </Box>
  );
};
